module.exports = __webpack_public_path__ + "static/media/29DUNON13.2e5e5365.jpg";